import avatar1 from "../../assets/images/users/avatar-1.jpg"
import avatar2 from "../../assets/images/users/avatar-2.jpg"
import avatar3 from "../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../assets/images/users/avatar-4.jpg"
import avatar5 from "../../assets/images/users/avatar-5.jpg"
import avatar6 from "../../assets/images/users/avatar-6.jpg"
import avatar7 from "../../assets/images/users/avatar-7.jpg"
import avatar8 from "../../assets/images/users/avatar-8.jpg"

import cityBanner from "../../assets/images/city-hub/dallas-banner.jpg"
import cityCard from "../../assets/images/city-hub/city-card.jpg"
import cityThumbDallas from "../../assets/images/city-hub/cities/dallas.png"
import cityThumbNyc from "../../assets/images/city-hub/cities/nyc.png"
import cityThumbLa from "../../assets/images/city-hub/cities/la.png"
import cityThumbSf from "../../assets/images/city-hub/cities/sf.png"
import cityThumbChicago from "../../assets/images/city-hub/cities/chicago.png"
import cityThumbAustin from "../../assets/images/city-hub/cities/austin.png"
import cityThumbMiami from "../../assets/images/city-hub/cities/miami.png"
import cityThumbPortland from "../../assets/images/city-hub/cities/portland.png"

// Reuse one Figma city/card image across all static card media
const callImg1 = cityCard
const callImg2 = cityCard
const callImg3 = cityCard
const callImg4 = cityCard
const callImg5 = cityCard

export const CITY = {
  name: "Dallas, TX",
  type: "Primary City",
  tagline: "Discover, connect, and create opportunities in your city.",
  banner: cityBanner,
}

export const YOUR_CITIES = [
  {
    id: "dallas",
    name: "Dallas, TX",
    members: "1.4k members",
    tier: "primary",
    thumb: cityThumbDallas,
  },
  {
    id: "nyc",
    name: "New York City, NY",
    members: "4.8k members",
    tier: "secondary",
    thumb: cityThumbNyc,
  },
  {
    id: "la",
    name: "Los Angeles, CA",
    members: "5.2k members",
    tier: "tertiary",
    thumb: cityThumbLa,
  },
]

export const OTHER_CITIES = [
  {
    id: "sf",
    name: "San Francisco, CA",
    members: "2.4k members",
    thumb: cityThumbSf,
  },
  {
    id: "chicago",
    name: "Chicago, IL",
    members: "1.8k members",
    thumb: cityThumbChicago,
  },
  {
    id: "austin",
    name: "Austin, TX",
    members: "3.1k members",
    thumb: cityThumbAustin,
  },
  {
    id: "miami",
    name: "Miami, FL",
    members: "1.2k members",
    thumb: cityThumbMiami,
  },
  {
    id: "portland",
    name: "Portland, OR",
    members: "890 members",
    thumb: cityThumbPortland,
  },
]

// Prefer cityHubTabs.js for route-aware tab config.
// Kept for detail pages / legacy imports.
export {
  CITY_HUB_TABS as TABS,
  VISIBLE_CITY_HUB_TABS as VISIBLE_TABS,
} from "./cityHubTabs"

export const PHOTOS = [
  { id: 1, src: callImg1, video: false },
  { id: 2, src: callImg2, video: true },
  { id: 3, src: callImg3, video: false },
  { id: 4, src: callImg4, video: false },
  { id: 5, src: callImg5, video: false },
  { id: 6, src: callImg1, video: true },
  { id: 7, src: callImg2, video: true },
  { id: 8, src: callImg3, video: false },
  { id: 9, src: callImg4, video: false },
]

export const COLLABORATORS = [
  {
    id: 1,
    name: "Mark Carlo",
    role: "Guitarist",
    level: 4,
    avatar: avatar1,
  },
  {
    id: 2,
    name: "Sophia Lee",
    role: "Photographer",
    level: 6,
    avatar: avatar2,
  },
  {
    id: 3,
    name: "Mark Carlo",
    role: "Guitarist",
    level: 8,
    avatar: avatar3,
  },
  {
    id: 4,
    name: "Amira Patel",
    role: "Musician",
    level: 4,
    avatar: avatar4,
  },
  {
    id: 5,
    name: "Ethan Wright",
    role: "Choreographer",
    level: 2,
    avatar: avatar5,
  },
  {
    id: 6,
    name: "Liam Jones",
    role: "Designer",
    level: 6,
    avatar: avatar6,
  },
]

export const CALLS = [
  {
    id: 1,
    title: "Need a Motion Designer for Short Film",
    headline: "Need a Motion Designer for Short Film",
    description:
      "Looking for a motion designer to create title sequences and VFX for an indie sci-fi short. Must have experience with After Effects and Cinema 4D.",
    city: "Global",
    category: "Film",
    posted: "2 days ago",
    deadline: "15 days left",
    status: "Active",
    active: true,
    responses: 8,
    responseAvatars: [avatar1, avatar2, avatar3],
    image: callImg1,
    poster: { name: "Angela Jessy", avatar: avatar6 },
    project: { name: "Chicago Cultural", color: "green" },
    projectCode: "CC",
  },
  {
    id: 2,
    title: "Seeking a Synth Player for Fall Tour",
    headline: "Seeking a Synth Player for Fall Tour",
    description:
      "Our electronic duo needs a synth player comfortable with analog gear for a 12-city fall tour.",
    city: "Dallas, TX",
    category: "Music",
    posted: "4 hours ago",
    deadline: "20 days left",
    status: "Active",
    active: true,
    responses: 4,
    responseAvatars: [avatar4, avatar5],
    image: callImg2,
    poster: { name: "Lena Harper", avatar: avatar7 },
    project: { name: "Neon Drift Collective", color: "green" },
  },
  {
    id: 3,
    title: "Cinematographer for Period Drama",
    headline: "Cinematographer for Period Drama",
    description:
      "Seeking a cinematographer with experience in natural lighting for a 1930s-set period drama.",
    city: "Dallas, TX",
    category: "Film",
    posted: "1 day ago",
    deadline: "18 days left",
    status: "Active",
    active: true,
    responses: 6,
    responseAvatars: [avatar6, avatar1, avatar8],
    image: callImg3,
    poster: { name: "Sophie Lane", avatar: avatar2 },
    project: { name: "Velvet Curtain Films", color: "orange" },
  },
  {
    id: 4,
    title: "Choreographer for Music Video Shoot",
    headline: "Choreographer for Music Video Shoot",
    description:
      "We need a contemporary choreographer for a 3-day music video production in downtown.",
    city: "Dallas, TX",
    category: "Performing Arts",
    posted: "6 hours ago",
    deadline: "12 days left",
    status: "Active",
    active: true,
    responses: 3,
    responseAvatars: [avatar3, avatar4],
    image: callImg4,
    poster: { name: "Nina Brooks", avatar: avatar5 },
    project: { name: "Kinetic Movement Co.", color: "purple" },
  },
  {
    id: 5,
    title: "Muralist for Community Art Project",
    headline: "Muralist for Community Art Project",
    description:
      "Paint a large-scale outdoor mural celebrating local culture in a revitalized neighborhood.",
    city: "Dallas, TX",
    category: "Visual Arts",
    posted: "3 days ago",
    deadline: "25 days left",
    status: "Active",
    active: true,
    responses: 6,
    responseAvatars: [avatar7, avatar8, avatar1],
    image: callImg5,
    poster: { name: "Ella Morgan", avatar: avatar6 },
    project: { name: "Canvas & Clay", color: "blue" },
  },
  {
    id: 6,
    title: "Producer for Debut Album Sessions",
    headline: "Producer for Debut Album Sessions",
    description:
      "Indie rock band seeking an experienced producer for a 10-track debut album recording.",
    city: "Dallas, TX",
    category: "Music",
    posted: "12 hours ago",
    deadline: "30 days left",
    status: "Active",
    active: true,
    responses: 10,
    responseAvatars: [avatar2, avatar3, avatar4],
    image: callImg2,
    poster: { name: "Chloe Bennett", avatar: avatar1 },
    project: { name: "Echo Chamber Records", color: "green" },
  },
  {
    id: 7,
    title: "Editor for Documentary Series",
    headline: "Editor for Documentary Series",
    description:
      "Post-production editor needed for a 6-episode documentary on local musicians.",
    city: "Dallas, TX",
    category: "Film",
    posted: "2 days ago",
    deadline: "22 days left",
    status: "Active",
    active: true,
    responses: 5,
    responseAvatars: [avatar5, avatar6],
    image: callImg3,
    poster: { name: "Owen Diaz", avatar: avatar7 },
    project: { name: "Reel Stories Media", color: "orange" },
  },
  {
    id: 8,
    title: "Sculptor for Gallery Exhibition",
    headline: "Sculptor for Gallery Exhibition",
    description:
      "Looking for a sculptor to contribute a mixed-media piece for a fall gallery exhibition.",
    city: "Dallas, TX",
    category: "Visual Arts",
    posted: "5 hours ago",
    deadline: "28 days left",
    status: "Active",
    active: true,
    responses: 7,
    responseAvatars: [avatar8, avatar1, avatar2],
    image: callImg4,
    poster: { name: "Ava Moreno", avatar: avatar3 },
    project: { name: "Inkwell Collective", color: "purple" },
  },
]

export const RESPONSES = {
  1: [
    {
      id: 101,
      name: "Sarah Jenkins",
      badge: "Motion Designer",
      time: "2 hours ago",
      avatar: avatar1,
      text: "I've worked on several indie shorts and have a strong background in sci-fi VFX. I'd love to share my portfolio and discuss the title sequence concept.",
      likes: 5,
      replies: 2,
    },
    {
      id: 103,
      name: "Marcus Thorne",
      badge: "Freelancer",
      time: "5 hours ago",
      avatar: avatar4,
      text: "I'm available immediately and have a strong background in Cinema 4D. I can deliver high-quality renders within tight deadlines.",
      likes: 3,
      replies: 0,
    },
    {
      id: 104,
      name: "David Kim",
      badge: "3D Artist",
      time: "1 day ago",
      avatar: avatar5,
      text: "I specialize in 3D modeling for film. I can help with the VFX elements and ensure they integrate seamlessly with the live-action footage.",
      likes: 2,
      replies: 0,
    },
  ],
}

export const COMMENTS = {
  101: [
    {
      id: 1001,
      name: "Alex Chen",
      author: true,
      time: "1 hour ago",
      avatar: avatar6,
      text: "Great to hear that! Please share your portfolio link so we can review your VFX work.",
    },
  ],
}

export const INBOX = [
  {
    id: 1,
    title: "Are Handwound Pickups Really Worth the Price?",
    description:
      "I've been debating between handwound and machine-wound pickups for my Strat. Anyone noticed a real tonal difference or is it just hype?",
    category: "Music",
    city: "Global",
    posted: "3h ago",
    postedLong: "3 hours ago",
    deadline: "15 days left",
    active: true,
    poster: { name: "Lena Harper", avatar: avatar7 },
    project: { name: "Neon Drift Collective" },
    responses: 12,
    responseAvatars: [avatar1, avatar2, avatar3],
    image: callImg1,
  },
  {
    id: 2,
    title: "Best Affordable Lens for Low-Light Indie Shoots?",
    description:
      "Shooting a short film mostly at night on a tight budget. What lenses are you all using for low-light without breaking the bank?",
    category: "Film",
    city: "Global",
    posted: "7h ago",
    postedLong: "7 hours ago",
    deadline: "15 days left",
    active: true,
    poster: { name: "Maya Collins", avatar: avatar3 },
    project: { name: "Parallax Studios" },
    responses: 8,
    responseAvatars: [avatar4, avatar5, avatar6],
    image: callImg2,
  },
  {
    id: 3,
    title: "How Do You Handle Color Grading on a DIY Budget?",
    description:
      "I can't afford DaVinci Resolve Studio yet. What free tools or workflows are people using to get a cinematic color grade?",
    detailDescription:
      "I'm trying to get a cinematic color grade without breaking the bank. What free tools or workflows are people using to get a cinematic color grade? Looking for tips on color LUTs, free plugins, and budget-friendly alternatives.",
    category: "Film",
    city: "Global",
    posted: "2h ago",
    postedLong: "2 hours ago",
    deadline: "15 days left",
    active: true,
    poster: { name: "Sophie Lang", avatar: avatar2 },
    project: { name: "Velvet Curtain Films" },
    responses: 16,
    responseAvatars: [avatar6, avatar1, avatar8, avatar4],
    image: callImg3,
  },
  {
    id: 4,
    title: "Tips for Preventing Knee Injuries in Contemporary Dance?",
    description:
      "I've been dealing with recurring knee pain after rehearsals. Any dancers here have advice on warm-ups or braces that actually help?",
    category: "Performing Arts",
    city: "Global",
    posted: "5h ago",
    postedLong: "5 hours ago",
    deadline: "15 days left",
    active: true,
    poster: { name: "Nina Brooks", avatar: avatar5 },
    project: { name: "Kinetic Movement Co." },
    responses: 9,
    responseAvatars: [avatar3, avatar7, avatar1],
    image: callImg4,
  },
  {
    id: 5,
    title: "Oil vs Acrylic for Large-Scale Outdoor Murals?",
    description:
      "Planning my first outdoor mural and unsure which paint holds up better to Texas heat. What's your experience with weathering?",
    category: "Visual Arts",
    city: "Global",
    posted: "1d ago",
    postedLong: "1 day ago",
    deadline: "15 days left",
    active: true,
    poster: { name: "Ella Morgan", avatar: avatar6 },
    project: { name: "Canvas & Clay" },
    responses: 22,
    responseAvatars: [avatar8, avatar2, avatar3],
    image: callImg5,
  },
  {
    id: 6,
    title: "Why Does My Mix Sound Flat on Speakers?",
    description:
      "Every time I think my mix is perfect on my ATH-M50s but loses all its depth on monitors. What am I doing wrong?",
    category: "Music",
    city: "Global",
    posted: "4h ago",
    postedLong: "4 hours ago",
    deadline: "15 days left",
    active: true,
    poster: { name: "Chloe Bennett", avatar: avatar1 },
    project: { name: "Echo Chamber Records" },
    responses: 14,
    responseAvatars: [avatar4, avatar5, avatar6],
    image: callImg2,
  },
]

export const EVENTS = [
  {
    id: 1,
    title: "Choreography Workshop",
    subtitle: "Developing new piece for August showcase",
    project: "Kinetic Movement Co.",
    host: "Nina Brooks",
    category: "Music",
    datetime: "Jun 30, 10:00 AM",
    duration: "3hrs",
    attendees: 48,
    status: "Join Session",
    statusColor: "action",
    image: callImg1,
    detailTitle: "Music Team Warmup Session",
    visibility: "Public",
    startedAt: "June 12, 2025, 3:45 PM",
    startedBy: { name: "Mark Carlo", avatar: avatar1 },
    sessionNote: "Warming up, reviewing setlist for Friday's gig",
  },
  {
    id: 2,
    title: "Documentary Edit Sprint",
    subtitle: "Rough cut assembly for episode 3",
    project: "Lone Star Film Collective",
    host: "Ava Chen",
    category: "Film",
    datetime: "Jul 1, 2:00 PM",
    duration: "4hrs",
    attendees: 23,
    status: "Finished",
    statusColor: "gray",
    image: callImg2,
    detailTitle: "Documentary Edit Sprint",
    visibility: "Public",
    startedAt: "July 1, 2025, 2:00 PM",
    startedBy: { name: "Ava Chen", avatar: avatar3 },
    sessionNote: "Rough cut assembly for episode 3",
  },
  {
    id: 3,
    title: "Friday Night Jam Session",
    subtitle: "Warming up for Saturday's jazz festival set",
    project: "Dallas Jazz Society",
    host: "Marcus Bell",
    category: "Music",
    datetime: "Jun 28, 7:00 PM",
    duration: "2.5hrs",
    attendees: 35,
    status: "Join Session",
    statusColor: "action",
    image: callImg3,
    detailTitle: "Friday Night Jam Session",
    visibility: "Public",
    startedAt: "June 28, 2025, 7:00 PM",
    startedBy: { name: "Marcus Bell", avatar: avatar4 },
    sessionNote: "Warming up for Saturday's jazz festival set",
  },
  {
    id: 4,
    title: "Mural Painting Session",
    subtitle: "Working on the Main Street community mural",
    project: "Deep Ellum Arts Foundation",
    host: "Ella Morgan",
    category: "Visual Arts",
    datetime: "Jul 2, 9:00 AM",
    duration: "5.25hrs",
    attendees: 19,
    status: "Finished",
    statusColor: "gray",
    image: callImg4,
    detailTitle: "Mural Painting Session",
    visibility: "Public",
    startedAt: "July 2, 2025, 9:00 AM",
    startedBy: { name: "Ella Morgan", avatar: avatar6 },
    sessionNote: "Working on the Main Street community mural",
  },
  {
    id: 5,
    title: "Open Ceramics Studio",
    subtitle: "Glazing pieces for the weekend gallery opening",
    project: "Canvas & Clay",
    host: "Tara Kim",
    category: "Visual Arts",
    datetime: "Jun 29, 1:00 PM",
    duration: "3.75hrs",
    attendees: 12,
    status: "Join Session",
    statusColor: "action",
    image: callImg5,
    detailTitle: "Open Ceramics Studio",
    visibility: "Public",
    startedAt: "June 29, 2025, 1:00 PM",
    startedBy: { name: "Tara Kim", avatar: avatar5 },
    sessionNote: "Glazing pieces for the weekend gallery opening",
  },
  {
    id: 6,
    title: "Band Rehearsal — The Nightcaps",
    subtitle: "Running through setlist for Friday gig",
    project: "Echo Chamber Records",
    host: "Chloe Bennett",
    category: "Music",
    datetime: "Jul 3, 6:00 PM",
    duration: "2hrs",
    attendees: 15,
    status: "Finished",
    statusColor: "gray",
    image: callImg1,
    detailTitle: "Band Rehearsal — The Nightcaps",
    visibility: "Public",
    startedAt: "July 3, 2025, 6:00 PM",
    startedBy: { name: "Chloe Bennett", avatar: avatar1 },
    sessionNote: "Running through setlist for Friday gig",
  },
]

export const EVENT_ATTENDEES = [
  { id: 1, name: "Nina", fullName: "Nina Brooks", avatar: avatar5, status: "In Session", note: "Leading the workshop sessions", joinedAt: "10:00:00", logged: "2.5hrs", exitAt: "--", online: true },
  { id: 2, name: "Sophie", fullName: "Sophie Lang", avatar: avatar2, status: "Exited", note: "Warming up, reviewing setlist for Friday's gig", joinedAt: "12:45:00", logged: "2.5hrs", exitAt: "02:45:00", online: false },
  { id: 3, name: "Marcus", fullName: "Marcus Bell", avatar: avatar4, status: "Invited", note: "Mixing last night's live session tracks", joinedAt: "14:00:00", logged: "--", exitAt: "--", online: true },
  { id: 4, name: "Priya", fullName: "Priya Shah", avatar: avatar3, status: "Paused", note: "Looking forward to the August showcase", joinedAt: "14:30:00", logged: "--", exitAt: "--", online: false },
  { id: 5, name: "Ethan", fullName: "Ethan Wright", avatar: avatar6, status: "Exited", note: "Practicing guitar solos for band rehearsal", joinedAt: "14:30:00", logged: "--", exitAt: "--", online: false },
  { id: 6, name: "Lena", fullName: "Lena Harper", avatar: avatar7, status: "In Session", note: "Running through setlist for Friday gig", joinedAt: "13:15:00", logged: "0.5hrs", exitAt: "--", online: true },
  { id: 7, name: "Omar", fullName: "Omar Diaz", avatar: avatar8, status: "Exited", note: "Warming up, reviewing setlist for Friday's gig", joinedAt: "12:45:00", logged: "2.5hrs", exitAt: "02:45:00", online: false },
  { id: 8, name: "Yuki", fullName: "Yuki Tanaka", avatar: avatar1, status: "Invited", note: "Mixing last night's live session tracks", joinedAt: "09:30:00", logged: "--", exitAt: "--", online: true },
  { id: 9, name: "Felix", fullName: "Felix Moore", avatar: avatar2, status: "In Session", note: "Leading the workshop sessions", joinedAt: "10:15:00", logged: "1.5hrs", exitAt: "--", online: true },
  { id: 10, name: "Nina", fullName: "Nina Patel", avatar: avatar3, status: "In Session", note: "Running through setlist for Friday gig", joinedAt: "11:00:00", logged: "1hr", exitAt: "--", online: true },
  { id: 11, name: "Raj", fullName: "Raj Kapoor", avatar: avatar4, status: "Paused", note: "Looking forward to the August showcase", joinedAt: "11:30:00", logged: "--", exitAt: "--", online: false },
  { id: 12, name: "Ava", fullName: "Ava Chen", avatar: avatar5, status: "In Session", note: "Warming up, reviewing setlist for Friday's gig", joinedAt: "10:00:00", logged: "2hrs", exitAt: "--", online: true },
  { id: 13, name: "Marcus", fullName: "Marcus Lee", avatar: avatar6, status: "Exited", note: "Practicing guitar solos for band rehearsal", joinedAt: "09:00:00", logged: "3hrs", exitAt: "12:00:00", online: false },
  { id: 14, name: "Chloe", fullName: "Chloe Bennett", avatar: avatar7, status: "In Session", note: "Running through setlist for Friday gig", joinedAt: "10:30:00", logged: "1.75hrs", exitAt: "--", online: true },
  { id: 15, name: "Kai", fullName: "Kai Nguyen", avatar: avatar8, status: "Invited", note: "Mixing last night's live session tracks", joinedAt: "15:00:00", logged: "--", exitAt: "--", online: true },
]

export const INBOX_RESPONSES = {
  1: [
    {
      id: 101,
      name: "Jake Rivera",
      badge: "Guitarist",
      time: "2 hours ago",
      avatar: avatar1,
      text: "Handwound pickups can sound warmer, but a lot depends on the wind and magnets. Try A/B'ing before you spend the money.",
      likes: 5,
      replies: 0,
    },
  ],
  3: [
    {
      id: 301,
      name: "Jake Rivera",
      badge: "Colorist",
      time: "2 hours ago",
      avatar: avatar1,
      text: "The free version of DaVinci Resolve is incredibly powerful. You can still use LUTs, curves, and most color wheels without the Studio features. I've graded a few shorts using just the free version and it holds up well.",
      likes: 12,
      replies: 1,
    },
    {
      id: 302,
      name: "Emily Chen",
      badge: "Photographer",
      time: "4 hours ago",
      avatar: avatar3,
      text: "If you're using a camera that supports it, an ACES workflow can save you a ton of time in the grade. It's free, standardized, and keeps your color data intact even when you're working on a budget.",
      likes: 9,
      replies: 0,
    },
    {
      id: 303,
      name: "Marcus Bell",
      badge: "Colorist",
      time: "6 hours ago",
      avatar: avatar4,
      text: "I've had great luck with the FilmConvert plugin. It's not free, but it's affordable and gives you a very film-like response curve. The presets are also a great starting point for DIY color grading.",
      likes: 7,
      replies: 0,
    },
  ],
}

export const INBOX_COMMENTS = {
  301: [
    {
      id: 3001,
      name: "Sophie Lang",
      author: true,
      time: "1 hour ago",
      avatar: avatar2,
      text: "Thanks, Jake! I didn't realize the free version still supported LUTs. Do you have a favorite workflow for matching skin tones on a low-budget set?",
    },
  ],
}

export const REVIEWS = [
  {
    id: 1,
    title: "Neon Drift at Deep Ellum",
    text: "Caught the Neon Drift show at Trees last Friday. Tight set, crowd energy was electric, and the venue sound was pristine. Easily one of the best local acts this year.",
    image: callImg1,
    reviewer: { name: "Sophia Lee", avatar: avatar2 },
    date: "Jul 1, 2025",
    category: "Music",
  },
  {
    id: 2,
    title: "Lone Star Indie Shorts Night",
    text: "Parallax Studios' indie shorts night at the Texas Theatre delivered. Strong writing, thoughtful edits, and a packed house that stayed through the Q&A.",
    image: callImg2,
    reviewer: { name: "James Ortiz", avatar: avatar3 },
    date: "Jun 30, 2025",
    category: "Film",
  },
  {
    id: 3,
    title: "Canvas & Clay — summer exhibit",
    text: "The summer ceramic show at Canvas & Clay felt intimate and sharp. Glaze work was consistent, and the outdoor courtyard install stole the night.",
    image: callImg3,
    reviewer: { name: "Emily Johnson", avatar: avatar1 },
    date: "Jun 29, 2025",
    category: "Visual Arts",
  },
  {
    id: 4,
    title: "Kinetic Movement Co. workshop",
    text: "Nina Brooks' choreography workshop pushed the room hard in the best way. Clear direction, generous feedback, and a piece that already feels stage-ready.",
    image: callImg4,
    reviewer: { name: "Andre Williams", avatar: avatar5 },
    date: "Jul 2, 2025",
    category: "Performing Arts",
  },
  {
    id: 5,
    title: "Deep Ellum Zine Fair",
    text: "Tables overflowing with local print, comics, and photo books. The fair made Dallas' DIY press scene feel alive — buy something, talk to makers, leave inspired.",
    image: callImg5,
    reviewer: { name: "Ryan Carter", avatar: avatar6 },
    date: "Jul 4, 2025",
    category: "Literary",
  },
  {
    id: 6,
    title: "Reunion Tower Sessions — live album review",
    text: "Recorded live above downtown, this album captures late-night jazz with room noise and all. Warm takes, patient solos, and a city skyline you can almost hear.",
    image: callImg1,
    reviewer: { name: "Tara Kim", avatar: avatar7 },
    date: "Jul 3, 2025",
    category: "Music",
  },
]

/** Values are sent as `areas_of_interest` strings to the API. */
export const REVIEW_INTEREST_OPTIONS = [
  { value: "Live Shows", label: "Live Shows" },
  { value: "Albums", label: "Albums" },
  { value: "Indie Films", label: "Indie Films" },
  { value: "Art Exhibits", label: "Art Exhibits" },
  { value: "Zines & Print", label: "Zines & Print" },
]

export const GALLERY = [
  {
    id: 1,
    title: "Golden Hour, Reunion",
    src: callImg1,
    photographer: { name: "Sophia Lee", avatar: avatar2 },
    likes: 142,
    date: "Jul 5, 2025",
    category: "Visual Arts",
  },
  {
    id: 2,
    title: "Deep Ellum Murals",
    src: callImg3,
    photographer: { name: "Marcus Bell", avatar: avatar4 },
    likes: 98,
    date: "Jul 5, 2025",
    category: "Visual Arts",
  },
  {
    id: 3,
    title: "Trinity Groves View",
    src: callImg4,
    photographer: { name: "Emily Johnson", avatar: avatar1 },
    likes: 231,
    date: "Jul 5, 2025",
    category: "Visual Arts",
  },
  {
    id: 4,
    title: "Bishop Arts Colors",
    src: callImg5,
    photographer: { name: "Tara Kim", avatar: avatar7 },
    likes: 76,
    date: "Jul 5, 2025",
    category: "Visual Arts",
  },
  {
    id: 5,
    title: "Northpark Shadows",
    src: callImg2,
    photographer: { name: "Lena Torres", avatar: avatar8 },
    likes: 94,
    date: "Jun 20, 2025",
    category: "Visual Arts",
  },
  {
    id: 6,
    title: "Oak Lawn at Dusk",
    src: callImg1,
    photographer: { name: "Kai Nakamura", avatar: avatar3 },
    likes: 178,
    date: "Jun 18, 2025",
    category: "Visual Arts",
  },
  {
    id: 7,
    title: "Cedars District Light",
    src: callImg3,
    photographer: { name: "Priya Sharma", avatar: avatar5 },
    likes: 87,
    date: "Jun 15, 2025",
    category: "Visual Arts",
  },
  {
    id: 8,
    title: "White Rock Reflections",
    src: callImg4,
    photographer: { name: "David Chen", avatar: avatar6 },
    likes: 215,
    date: "Jun 12, 2025",
    category: "Visual Arts",
  },
]

export const BLOGS = [
  {
    id: 1,
    title: "Why Dallas is the Next Big Arts City",
    excerpt:
      "From Deep Ellum galleries to Bishop Arts pop-ups, Dallas is quietly becoming one of the most exciting creative hubs.",
    intro:
      "From Deep Ellum galleries to Bishop Arts pop-ups, Dallas is quietly becoming one of the most exciting creative hubs in the United States. What was once known primarily for its business districts and sports teams is now home to a thriving arts community that rivals cities like Austin and Portland.",
    category: "City Life",
    readTime: "6 min read",
    published: "July 18, 2025",
    image: callImg1,
    author: {
      name: "Sarah Jenkins",
      avatar: avatar2,
      role: "Arts & Culture Correspondent",
    },
    tags: ["Arts", "Dallas", "Culture", "Deep Ellum", "Bishop Arts"],
    likes: 24,
    comments: 8,
    quote: {
      text: "Dallas has this incredible energy right now. You can feel it in the murals going up on every block, in the pop-up shows, in the way people are talking about art as something essential, not optional.",
      attribution: "Maria Torres, Gallery Owner, Deep Ellum",
    },
    content: [
      {
        heading: "The Deep Ellum Renaissance",
        text: "Deep Ellum has always had an edge — from its jazz roots in the 1920s to its punk-rock era in the '80s. But the latest wave of transformation is different. Independent galleries, immersive art installations, and artist-run co-ops are popping up alongside the music venues and street murals the neighborhood is famous for.",
      },
      {
        heading: "Bishop Arts: Where Community Meets Creativity",
        text: "South of downtown, the Bishop Arts District offers a more intimate creative experience. Small boutiques showcase local makers, while pop-up exhibitions transform storefronts into temporary galleries. The community-driven approach here has created an ecosystem where emerging artists can experiment and find their audience without the pressure of traditional gallery spaces.",
      },
      {
        heading: "A City Investing in Its Creative Future",
        text: "The Dallas Arts District — the largest contiguous urban arts district in the nation — continues to anchor the city's cultural identity. But it's the grassroots movements happening outside these institutions that are truly reshaping what it means to be an artist in Dallas. City-funded grants, affordable studio spaces, and collaborative residency programs have all contributed to a creative infrastructure that supports artists at every stage of their career.",
      },
      {
        heading: "The Role of Technology in Dallas Arts",
        text: "What sets Dallas apart from other emerging arts cities is its embrace of technology. Digital art installations, AR-enhanced gallery walks, and blockchain-verified art sales are becoming commonplace. The city's tech sector has naturally intersected with its creative community, producing innovative hybrid experiences that attract visitors from around the world.",
      },
      {
        heading: "Community Voices",
        showQuoteAfter: true,
      },
      {
        text: "Local organizations like AMOK.EARTH are playing a crucial role in connecting Dallas creators across disciplines. By providing a platform for collaboration, these community-driven tools help artists find each other, share resources, and build projects together — turning individual talent into collective momentum.",
      },
      {
        heading: "What's Next for Dallas",
        text: "With major new developments planned for the Design District and continued investment in public art programs, Dallas shows no signs of slowing down. Whether you're a visual artist, musician, filmmaker, or designer, the city is sending a clear message: come create here. The infrastructure is ready, the community is welcoming, and the opportunities are growing every day.",
        level: "h2",
      },
    ],
  },
  {
    id: 2,
    title: "Hidden Music Venues to Visit",
    excerpt:
      "Beyond the mainstream spots, Dallas has a thriving underground music scene. Here are the venues locals swear by.",
    intro:
      "Beyond the mainstream spots, Dallas has a thriving underground music scene. From warehouse shows to intimate listening rooms, here are the venues locals swear by.",
    category: "Music",
    readTime: "5 min read",
    published: "July 16, 2025",
    image: callImg2,
    author: {
      name: "Marcus Bell",
      avatar: avatar4,
      role: "Music Correspondent",
    },
    tags: ["Music", "Dallas", "Venues"],
    likes: 18,
    comments: 5,
    content: [
      {
        heading: "The Underground Circuit",
        text: "Dallas's music culture runs deep. Hidden venues in warehouses, basements, and art spaces host everything from experimental jazz to indie rock.",
      },
    ],
  },
  {
    id: 3,
    title: "A Weekend in Design District",
    excerpt:
      "How to spend a perfect weekend exploring galleries, studios, and creative spaces in Dallas's Design District.",
    intro:
      "How to spend a perfect weekend exploring galleries, studios, and creative spaces in Dallas's Design District.",
    category: "Visual Arts",
    readTime: "7 min read",
    published: "July 14, 2025",
    image: callImg3,
    author: {
      name: "Tara Kim",
      avatar: avatar7,
      role: "Arts Correspondent",
    },
    tags: ["Visual Arts", "Dallas", "Design District"],
    likes: 31,
    comments: 12,
    content: [],
  },
  {
    id: 4,
    title: "Dallas Mural Festival Recap 2025",
    excerpt:
      "This year's mural festival brought 40 artists from around the world. Here's a look at the best new walls.",
    intro:
      "This year's mural festival brought 40 artists from around the world. Here's a look at the best new walls.",
    category: "Festivals",
    readTime: "4 min read",
    published: "July 10, 2025",
    image: callImg4,
    author: {
      name: "Andre Williams",
      avatar: avatar5,
      role: "Culture Writer",
    },
    tags: ["Festivals", "Dallas", "Murals"],
    likes: 42,
    comments: 9,
    content: [],
  },
  {
    id: 5,
    title: "How AMOK.EARTH Changed My Career",
    excerpt:
      "One photographer's story of going from solo hobbyist to full-time creative through the Dallas community.",
    intro:
      "One photographer's story of going from solo hobbyist to full-time creative through the Dallas community.",
    category: "Community",
    readTime: "9 min read",
    published: "July 8, 2025",
    image: callImg5,
    author: {
      name: "Emily Johnson",
      avatar: avatar1,
      role: "Community Storyteller",
    },
    tags: ["Community", "Dallas", "Careers"],
    likes: 56,
    comments: 14,
    content: [],
  },
  {
    id: 6,
    title: "State Fair of Texas: What to Expect",
    excerpt:
      "A guide to navigating the biggest annual festival in Dallas — from the food to the art exhibits and live performances.",
    intro:
      "A guide to navigating the biggest annual festival in Dallas — from the food to the art exhibits and live performances.",
    category: "Festivals",
    readTime: "8 min read",
    published: "July 5, 2025",
    image: callImg2,
    author: {
      name: "Grace Liu",
      avatar: avatar8,
      role: "Lifestyle Correspondent",
    },
    tags: ["Festivals", "Dallas", "Events"],
    likes: 27,
    comments: 6,
    content: [],
  },
]

export const CREATORS = [
  {
    id: 1,
    name: "Sophia Lee",
    role: "Photographer",
    xp: 2550,
    projects: 12,
    joined: "Mar 15, 2025",
    avatar: avatar2,
    category: "Visual Arts",
  },
  {
    id: 2,
    name: "Marcus Bell",
    role: "Sound Designer",
    xp: 4200,
    projects: 18,
    joined: "Jan 8, 2025",
    avatar: avatar4,
    category: "Music",
  },
  {
    id: 3,
    name: "Emily Johnson",
    role: "Ceramicist",
    xp: 3800,
    projects: 15,
    joined: "Feb 22, 2025",
    avatar: avatar1,
    category: "Visual Arts",
  },
  {
    id: 4,
    name: "James Ortiz",
    role: "Screenwriter",
    xp: 1900,
    projects: 8,
    joined: "Apr 3, 2025",
    avatar: avatar3,
    category: "Film",
  },
  {
    id: 5,
    name: "Tara Kim",
    role: "Muralist",
    xp: 5200,
    projects: 22,
    joined: "Dec 10, 2024",
    avatar: avatar7,
    category: "Visual Arts",
  },
  {
    id: 6,
    name: "Ryan Carter",
    role: "Guitarist",
    xp: 3600,
    projects: 14,
    joined: "Jan 28, 2025",
    avatar: avatar6,
    category: "Music",
  },
  {
    id: 7,
    name: "Andre Williams",
    role: "Choreographer",
    xp: 4800,
    projects: 20,
    joined: "Nov 5, 2024",
    avatar: avatar5,
    category: "Performing Arts",
  },
  {
    id: 8,
    name: "Grace Liu",
    role: "Poet & Writer",
    xp: 2100,
    projects: 9,
    joined: "Mar 30, 2025",
    avatar: avatar8,
    category: "Literary",
  },
  {
    id: 9,
    name: "Nina Reyes",
    role: "Textile Artist",
    xp: 2800,
    projects: 13,
    joined: "Jan 18, 2025",
    avatar: avatar2,
    category: "Visual Arts",
  },
  {
    id: 10,
    name: "Olivia Chen",
    role: "Curator",
    xp: 4100,
    projects: 16,
    joined: "May 5, 2025",
    avatar: avatar4,
    category: "Visual Arts",
  },
  {
    id: 11,
    name: "David Park",
    role: "Filmmaker",
    xp: 3300,
    projects: 11,
    joined: "Feb 14, 2025",
    avatar: avatar1,
    category: "Film",
  },
  {
    id: 12,
    name: "Daniel Ross",
    role: "Lighting Designer",
    xp: 2950,
    projects: 12,
    joined: "Feb 2, 2025",
    avatar: avatar3,
    category: "Performing Arts",
  },
  {
    id: 13,
    name: "Amira Patel",
    role: "Musician",
    xp: 3800,
    projects: 17,
    joined: "Apr 12, 2025",
    avatar: avatar5,
    category: "Music",
  },
  {
    id: 14,
    name: "Liam Jones",
    role: "Designer",
    xp: 1900,
    projects: 7,
    joined: "Jun 1, 2025",
    avatar: avatar6,
    category: "Visual Arts",
  },
  {
    id: 15,
    name: "Kai Nakamura",
    role: "DJ / Producer",
    xp: 2800,
    projects: 10,
    joined: "Mar 9, 2025",
    avatar: avatar7,
    category: "Music",
  },
  {
    id: 16,
    name: "Priya Sharma",
    role: "Documentary Editor",
    xp: 3500,
    projects: 14,
    joined: "Jan 21, 2025",
    avatar: avatar8,
    category: "Film",
  },
  {
    id: 17,
    name: "Chris Alvarez",
    role: "Stage Manager",
    xp: 2400,
    projects: 11,
    joined: "May 18, 2025",
    avatar: avatar1,
    category: "Performing Arts",
  },
  {
    id: 18,
    name: "Jordan Blake",
    role: "Zine Maker",
    xp: 1750,
    projects: 6,
    joined: "Apr 25, 2025",
    avatar: avatar2,
    category: "Literary",
  },
  {
    id: 19,
    name: "Sam Rivera",
    role: "Portrait Photographer",
    xp: 4600,
    projects: 19,
    joined: "Dec 2, 2024",
    avatar: avatar3,
    category: "Visual Arts",
  },
  {
    id: 20,
    name: "Maya Chen",
    role: "Indie Director",
    xp: 3900,
    projects: 12,
    joined: "Feb 28, 2025",
    avatar: avatar4,
    category: "Film",
  },
  {
    id: 21,
    name: "Noah Brooks",
    role: "Bass Player",
    xp: 3100,
    projects: 13,
    joined: "Mar 4, 2025",
    avatar: avatar5,
    category: "Music",
  },
  {
    id: 22,
    name: "Elena Vargas",
    role: "Dance Artist",
    xp: 2700,
    projects: 9,
    joined: "May 22, 2025",
    avatar: avatar6,
    category: "Performing Arts",
  },
  {
    id: 23,
    name: "Theo Martin",
    role: "Essayist",
    xp: 2200,
    projects: 8,
    joined: "Jun 8, 2025",
    avatar: avatar7,
    category: "Literary",
  },
  {
    id: 24,
    name: "Ava Singh",
    role: "Installation Artist",
    xp: 4400,
    projects: 15,
    joined: "Nov 19, 2024",
    avatar: avatar8,
    category: "Visual Arts",
  },
]
